module.exports = __webpack_public_path__ + "static/media/utensil-knife.885d6d77.svg";